import userSettings from "@/_mixins/user-settings-mixin"
import moment from "moment"
export default {
  mounted(){

  },
  mixins : [userSettings],
  computed: {
  },
  watch : {},
  data: () => ({
    localRegistrationFlag : false,
  }),
  methods : {
    // numberFormat(number)
    // {
    //   var result = number != 0
    //     ? numberFormatter(this.$store.state.settings.localization.numberFormatMask, number)
    //     : 0;
    //   return result;
    // },
    // currencyFormat(number)
    // {
    //   var result = number != 0 ?
    //     numberFormatter(this.$store.state.settings.localization.currencyFormatMask, number):
    //     0;
    //   return result;
    // },
    formatDate(dateString,dateFormatString)
    {
      dateFormatString = !!dateFormatString ? dateFormatString : this.globalDateFormat;
      var ret = !!dateString ? moment(dateString).format(dateFormatString) : null;
      return ret;
    },

    // formatNumber(number, formatString) {
    //   var result = numeral(number).format(formatString);
    //   return result;
    // },
    // parseFormattedNumber(string) {
    //   return numeral(string)._value; //as number;
    // }

  }
};
